import React, { memo } from 'react';
import { styled } from 'dripsy';
import { View as RView, Image as RImage } from 'react-native';
import { View, Image } from './core';
import { layout, isNative } from 'app/styles';
import { InlineLink } from './links';

export const FormImage = styled(RImage)({
  p: 2,
  width: 9,
  height: 9,
  mt: 1,
  borderRadius: '50%',
});

const select = !isNative ? { userSelect: 'none' } : { cursor: 'pointer' };

// @ts-ignore
export const CloseX = styled(Image)((p: any) => ({
  position: p.position ? p.position : 'absolute',
  ...select,
  zIndex: 10,
}));

export const ErrorBox = styled(RView)({
  mt: 2,
  p: 2,
  bg: 'errorA',
  borderColor: 'error',
  borderWidth: 1,
});

export const WarningBox = styled(RView)({
  mt: 2,
  p: 2,
  bg: 'warningA',
  borderColor: 'warning',
  borderWidth: 1,
});

export const MobileDivider = styled(RView)({
  height: 4 * 8,
  bg: 'dividerBg',
});

export const AbsoluteView = styled(RView)({
  position: 'absolute',
});

const SpacerComponent = ({
  children,
  sx,
  nestingLevel,
  additionalNesting,
  screenSize,
}) => {
  const total = (nestingLevel || 0) + (additionalNesting || 0);
  const UNIT = screenSize > 0 ? layout.NESTING_UNIT_RESONSIVE : layout.NESTING_UNIT;
  const pl = !(total * UNIT) ? {} : { pl: (total - (screenSize > 0 ? 1 : 0)) * UNIT * 8 };
  return <View sx={{ ...sx, position: 'relative', flex: 1, ...pl }}>{children}</View>;
};

export const Spacer = memo(SpacerComponent);

export const DividerLine = ({ sx }) => {
  return (
    <View
      sx={{
        height: 1,
        borderBottomWidth: 1,
        borderColor: 'lightBorder',
        ...sx,
      }}
    />
  );
};

export const Divider = ({ sx }) => {
  return (
    <View
      sx={{
        height: [4 * 8, 1],
        backgroundColor: ['dividerBg', 'transparent'],
        borderBottomWidth: [0, 1],
        borderColor: 'lightBorder',
        ...sx,
      }}
    />
  );
};

export const Tag = styled(RView)((p: any) => ({
  cursor: 'pointer',
  alignItems: 'center',
  justifyContent: 'center',
  bg: p.disabled ? 'lightGreyBg' : 'blue',
  color: p.disabled ? 'grey' : 'white',
  minWidth: 0,
  height: 5,
  padding: 1.5 * 8.0001,
  fontSize: 1.5 * 8.0001,
}));

export function EthAddress({ address }) {
  if (!address) return null;
  return (
    <InlineLink to={`https://etherscan.io/address/${address}`} target="_blank" external>
      {address.slice(0, 6) + '...' + address.slice(address.length - 4, address.length)}
    </InlineLink>
  );
}
